const TO = (props) => {
  return (
    <section className="w-full h-full flex items-center px-8">
      <div className="px-8 py-12 bg-white/40 w-2/3 rounded-xl">
        <p className="text-3xl md:text-4xl font-light text-white font-Berkshire border-b border-white mb-4">Tournament commentator</p>
        <p className='font-helvetica font-light leading-6 text-lg mb-2'>As a member of WestCoast Fighters, I do organize & Commentate for a tournament on various fighting games.</p>
        <p className='font-helvetica font-light leading-6 text-lg mb-2'>As passionate gamer, I also play Street Fighter V competetively under gamerTag, CRAZYFLAME.</p>
      </div>
    </section>
  );
}
export default TO;